import { useHookstate } from "@hookstate/core";
import { useCallback } from "react";
import { readerComponentsStore } from "../../../hookstate/readerComponentStore";

export function useEndInterstitial() {
  const showEndInterstitial = useHookstate(
    readerComponentsStore.showEndInterstitial,
  ).get({ noproxy: true });

  const toggleShowEndInterstitial = useCallback(() => {
    readerComponentsStore.showEndInterstitial.set(!showEndInterstitial);
  }, [showEndInterstitial]);

  const setShowEndInterstitial = (value: boolean) => {
    readerComponentsStore.showEndInterstitial.set(value);
  };

  return {
    showEndInterstitial,
    toggleShowEndInterstitial,
    setShowEndInterstitial,
  };
}
